import { render, staticRenderFns } from "./r-trader-config-page.vue?vue&type=template&id=7b201c68"
import script from "./r-trader-config-page.vue?vue&type=script&lang=js"
export * from "./r-trader-config-page.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/mira-merge-config/mira-merge-config/app-config/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7b201c68')) {
      api.createRecord('7b201c68', component.options)
    } else {
      api.reload('7b201c68', component.options)
    }
    module.hot.accept("./r-trader-config-page.vue?vue&type=template&id=7b201c68", function () {
      api.rerender('7b201c68', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/redactor/views/trader/r-trader-config-page.vue"
export default component.exports